import React from 'react';
import './Recommendations.css';
import chrisProfilePic from '../images/chris.jpg'; // Adjust the path based on your directory structure

const Recommendations: React.FC = () => {
  return (
    <div className='timeline-container'>
      <div className="recommendation-card">
        <div className="recommendation-header">
          <img src={chrisProfilePic} alt="Dr. Adebola Olutayo" className="profile-pic" />
          <div>
            <h3>Dr. Adebola Olutayo</h3>
            <p>Founder of We Guide Learning Initiative (WGLI) </p>
            <p className="date">January 4, 2024</p>
          </div>
        </div>
        <div className="recommendation-body">
          <p>🎓 "I had the privilege of working closely with Uchenna during his time at the University, where his exceptional talent in machine learning and software engineering truly stood out. His groundbreaking work on developing AI-driven solutions for sustainable energy management demonstrated not just technical excellence, but also a deep understanding of real-world applications.</p>

          <p>🚀 "What particularly impressed me was Uchenna's ability to bridge the gap between complex theoretical concepts and practical implementation. His research project on optimizing renewable energy systems using machine learning algorithms was not only academically rigorous but also had immediate industrial applications. The solution he developed achieved a remarkable 40% improvement in energy efficiency predictions.</p>

          <p>👥 "Beyond his technical capabilities, Uchenna showed outstanding leadership qualities as a peer mentor in our AI research group. He consistently helped fellow students grasp complex concepts and fostered a collaborative learning environment. His presentations at our departmental seminars were always well-received, showing his ability to communicate complex technical ideas to diverse audiences.</p>

          <p>💡 "His innovative thinking and problem-solving approach have left a lasting impact on our research community. I've watched him grow from a promising student to a accomplished professional, and his continued contributions to the field of AI and machine learning have been remarkable."</p>

        </div>
      </div>
    </div>
  );
};

export default Recommendations;
